import { DynamicVariable, mapResponsivePropToCSSVars } from "@faire/retailer-visitor-shared/lib/tailwindUtils";

export const MOBILE_BANNER_HEIGHT = 311;
export const TABLET_BANNER_HEIGHT = 326;
export const DESKTOP_BANNER_HEIGHT = 455;
export const XL_DESKTOP_BANNER_HEIGHT = 512;

const imageWrapperHeightVar: DynamicVariable<"--f-image-wrapper-height"> = {
  variable: "--f-image-wrapper-height",
  className: "h-(--f-image-wrapper-height)",
};

const imageWrapperHeightTabletVar: DynamicVariable<"--f-image-wrapper-height-md"> = {
  variable: "--f-image-wrapper-height-md",
  className: "md:h-(--f-image-wrapper-height-md)",
};

const imageWrapperHeightDesktopVar: DynamicVariable<"--f-image-wrapper-height-lg"> = {
  variable: "--f-image-wrapper-height-lg",
  className: "lg:h-(--f-image-wrapper-height-lg)",
};

const imageWrapperHeightXLargeAndAboveVar: DynamicVariable<"--f-image-wrapper-height-xl"> = {
  variable: "--f-image-wrapper-height-xl",
  className: "xl:h-(--f-image-wrapper-height-xl)",
};

export const imageWrapperHeightVars = mapResponsivePropToCSSVars(
  {
    mobileAndAbove: `${MOBILE_BANNER_HEIGHT}px`,
    tabletAndAbove: `${TABLET_BANNER_HEIGHT}px`,
    desktopAndAbove: `${DESKTOP_BANNER_HEIGHT}px`,
    xLargeAndAbove: `${XL_DESKTOP_BANNER_HEIGHT}px`,
  },
  {
    mobileAndAbove: imageWrapperHeightVar,
    tabletAndAbove: imageWrapperHeightTabletVar,
    desktopAndAbove: imageWrapperHeightDesktopVar,
    xLargeAndAbove: imageWrapperHeightXLargeAndAboveVar,
  }
);
